import Enum from './Enum.js';

export default class RoundRobinAssignableRoles extends Enum {
    static get entries() {
        return {
            user: 'user',
            bdc_user: 'bdc_user',
        };
    }

    static get USER() {
        return this.entries.user;
    }

    static get BDC_USER() {
        return this.entries.bdc_user;
    }

    static get translationGroup() {
        return 'roundRobin';
    }
}
